import { createGlobalStyle } from 'styled-components'
import { makeStyles } from '@material-ui/core'
import { MEDIA, MOBILE_TAB_BAR_HEIGHT, SAFE_AREA } from '~/common/styles/responsive'

export const GlobalStyle = createGlobalStyle`
	html {
		/* iOS inflates text after a rotation unless told not to. */
		-webkit-text-size-adjust: 100%;
		text-size-adjust: 100%;
	}
	body {
		color: ${({ theme }) => theme.palette.text.primary};
		background-color: #f8f8f8;
		-webkit-tap-highlight-color: transparent;
	}

	/*
	 * iOS Safari zooms into any focused field whose text is under 16px, and the
	 * viewport no longer forbids zooming (index.html). Many fields here are styled
	 * at 13–15px for desktop density, so on touch screens and phones every text
	 * field is held at 16px. Checkboxes, radios and ranges are not text fields.
	 */
	${MEDIA.touch}, ${MEDIA.phone} {
		input:not([type='checkbox']):not([type='radio']):not([type='range']):not([type='file']),
		textarea,
		select {
			font-size: 16px !important;
		}
	}
	
	input:-webkit-autofill,
	input:-webkit-autofill:hover, 
	input:-webkit-autofill:focus, 
	input:-webkit-autofill:active  {
		box-shadow: 0 0 0 30px white inset !important;
	}
	.grecaptcha-badge {
		display: none;
	}

  .MuiButton-contained.Mui-disabled {
    color: #ffff
  }

  .MuiSelect-select:focus {
    background-color: transparent;
  }
  .MuiAutocomplete-inputRoot[class*="MuiInput-root"] {
    padding-bottom: 0;
  }
	.MuiAutocomplete-popper {
		padding: 5px 0;
		> div {
			max-height: 300px;
			overflow: auto;
			
			> ul {
				max-height: inherit;
			}
		}
	}
  .MuiInputBase-root {
    padding-bottom: 0;
  }

	.pac-container {
		z-index: 3000;
	}

    form label.MuiFormLabel-root.Mui-error {
      color: ${({ theme }) => theme.palette.text.tertiary};
    }
	.MuiInputBase-input {
		padding: 6px 0 16px;
	}
	.MuiAutocomplete-inputRoot[class*="MuiInput-root"] .MuiAutocomplete-input:first-child {
		padding: 6px 0 16px;
	}
`

export const useStyles = makeStyles(() => ({
	/*
	 * Toasts sit at the bottom centre: clear of the header (search, bell, Ask AI),
	 * of the table toolbars under it and of the assistant launcher in the bottom
	 * right corner, which top-right toasts used to cover. Above dialogs (z-index
	 * 2000) so a result is never hidden behind the dialog that caused it.
	 */
	toastContainer: {
		bottom: '24px !important',
		zIndex: '10050 !important',
		[MEDIA.phone]: {
			bottom: '16px !important',
			left: '16px !important',
			right: '16px !important',
			transform: 'none !important',
			alignItems: 'center',
		},
		// Phones: sit above whatever is pinned to the bottom — Classic's tab bar, a chat
		// composer, or both — instead of on top of it, where a toast blocked taps on
		// the message field.
		[MEDIA.phone]: {
			'body:has([data-testid="mobile-tab-bar"]) &': {
				bottom: `calc(${MOBILE_TAB_BAR_HEIGHT + 16}px + ${SAFE_AREA.bottom}) !important`,
			},
			'body:has(.composer-box) &': {
				bottom: `calc(96px + ${SAFE_AREA.bottom}) !important`,
			},
			// A floating action button sits above the tab bar; toasts go above it.
			'body:has([data-testid="mobile-fab"]) &': {
				bottom: `calc(${MOBILE_TAB_BAR_HEIGHT + 88}px + ${SAFE_AREA.bottom}) !important`,
			},
			'body:has([data-testid="mobile-tab-bar"]):has(.composer-box) &': {
				bottom: `calc(${MOBILE_TAB_BAR_HEIGHT + 96}px + ${SAFE_AREA.bottom}) !important`,
			},
		},
	},
}))
